import { gql } from '@apollo/client';

export const GET_DOCUMENTS = gql`
  query DOCUMENTS_SERVICE_getDocuments($entityId: String!, $affiliatedId: String, $uploadStep: UploadStep!) {
    getDocuments(entityId: $entityId, affiliatedId: $affiliatedId, uploadStep: $uploadStep) {
      id
      status
      uploader {
        id
        name
        creationDateTime
      }
      filePath
      active
      type
      description
      templateLink
      eligibleForSignature
      fileSource
      restrictions
    }
  }
`;

export const ADD_ADDITIONAL_DOCUMENT = gql`
  mutation DOCUMENTS_SERVICE_addAdditionalDocument(
    $entityId: String!
    $type: String!
    $description: String!
    $templateLink: String!
    $fileName: String
  ) {
    addAdditionalDocument(
      entityId: $entityId
      type: $type
      description: $description
      templateLink: $templateLink
      fileName: $fileName
    )
  }
`;

export const EDIT_DOCUMENT = gql`
  mutation DOCUMENTS_SERVICE_editDocument($documentId: String!, $type: String!, $description: String!) {
    editDocument(documentId: $documentId, description: $description, type: $type) {
      id
    }
  }
`;

export const EDIT_TEMPLATE = gql`
  mutation DOCUMENTS_SERVICE_editTemplate($documentId: String!, $templateLink: String!, $fileName: String!) {
    editTemplate(documentId: $documentId, templateLink: $templateLink, fileName: $fileName)
  }
`;

export const UPLOAD_DOCUMENT = gql`
  mutation DOCUMENTS_SERVICE_uploadDocument(
    $entityId: String!
    $sponsorId: String!
    $type: String!
    $fileName: String!
  ) {
    uploadDocument(entityId: $entityId, sponsorId: $sponsorId, type: $type, fileName: $fileName)
  }
`;
export const UPLOAD_RFQ_RESPONSE_DOCUMENT = gql`
  mutation DOCUMENTS_SERVICE_uploadRFQResponse(
    $entityId: String!
    $type: String!
    $description: String!
    $fileName: String
  ) {
    uploadRFQResponse(entityId: $entityId, type: $type, description: $description, fileName: $fileName)
  }
`;

export const GET_DOWNLOAD_DOCUMENT_URL = gql`
  query DOCUMENTS_SERVICE_getDownloadDocumentURL($documentId: String!) {
    getDownloadDocumentURL(documentId: $documentId)
  }
`;

export const REMOVE_UPLOAD = gql`
  mutation DOCUMENTS_SERVICE_removeUpload($documentId: String!) {
    removeUpload(documentId: $documentId)
  }
`;

export const DISCARD_DOCUMENT = gql`
  mutation DOCUMENTS_SERVICE_discardDocument($documentId: String!) {
    discardDocument(documentId: $documentId)
  }
`;

export const REQUEST_FOR_SIGNATURE = gql`
  mutation DOCUMENTS_SERVICE_signatureRequest($documentId: String!, $recipient: Recipient!) {
    signatureRequest(documentId: $documentId, recipient: $recipient)
  }
`;

export const APPLY_USER_ACTION = gql`
  mutation DOCUMENTS_SERVICE_applyUserAction($documentId: String!, $userAction: UserAction) {
    applyUserAction(documentId: $documentId, userAction: $userAction) {
      id
    }
  }
`;

export const SEND_SIGN_FILE_REMINDER = gql`
  mutation DOCUMENTS_SERVICE_sendSignFileReminder($documentId: String!) {
    sendSignFileReminder(documentId: $documentId)
  }
`;

export const REQUEST_FOR_SIGNATURE_FOR_FILE = gql`
  mutation DOCUMENTS_SERVICE_signatureRequestForFile($periodId: String!, $recipient: Recipient!, $file: FileInput!) {
    signatureRequestForFile(periodId: $periodId, recipient: $recipient, file: $file)
  }
`;

export const UPDATE_SUBSCRIBER_REASON = gql`
  mutation DOCUMENTS_SERVICE_updateSubscriberReason(
    $entityId: String!
    $sponsorId: String!
    $affiliatedId: String!
    $reason: String!
  ) {
    updateSubscriberReason(entityId: $entityId, sponsorId: $sponsorId, affiliatedId: $affiliatedId, reason: $reason)
  }
`;

export const SUBMIT_DOCUMENTS = gql`
  mutation DOCUMENTS_SERVICE_submitDocuments($entityId: String!, $uploadStep: UploadStep!) {
    submitDocuments(entityId: $entityId, uploadStep: $uploadStep)
  }
`;
